<template>
    <div class="setMeal">
        <!-- 导航栏 -->
        <topHead><h3 slot="header">套餐余量</h3></topHead>
        <!-- 内容 -->
        <div class="main">
            <!-- 头部 -->
            <div class="balance_top">
                <p>您好，您当前的【{{ packageName }}】使用情况为</p>
            </div>
            <!-- 列表 -->
            <ul class="set_meal_list">
                <li v-for="(item,index) in list" :key="index">
                    <div class="setMeal_title">{{item.title}}</div>
                    <div class="setMeal_contet" v-for="(v,index) in item.list" :key="index">
                        <div class="setMeal_contet_top">
                            <h5><span></span>{{v.title}}</h5>
                            <p v-if="v.type == true">总量:{{v.total}}</p>
                        </div>
                        <div class="setMeal_contet_middle">
                            <van-progress
                                pivot-text=""
                                color="#F07541"
                                :percentage="v.percentage"
                                stroke-width="8"
                                v-if="v.type == true"
                            />
                        </div>
                        <div class="setMeal_contet_bottom">
                            <p>已用：{{v.used}}</p>
                            <p v-if="v.type == true">剩余：{{v.surplus}}</p>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- 底部 -->
            <div class="explain">
                <div class="explain_title">说明</div>
                <p v-html="explain"></p>
            </div>
        </div>
    </div>
</template>

<script>
import API from "../../common/api/api"
import topHead from "../../components/topHead.vue"
export default {
    name: "setMeal",
    data() {
        return {
            packageName: "",
            explain:'',
            list:[]
        }
    },
    mounted() {
        this.setMeal()
    },
    methods: {
        setMeal() {
            let token = localStorage.getItem("token")
            API.getJson("QUERY_SET_MEAL", {
                token: token,
            }).then(res => {
                this.packageName = res.packageName
                this.explain = res.explain
                this.list = res.list
            })
        },
    },
    components: {
        topHead,
    },
}
</script>

<style lang="scss" scoped>
.main {
    padding: 0 px2rem(30);
}
// 头部
.balance_top {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: px2rem(90);
    line-height: px2rem(90);
    background-color: #FFD614;
    border-radius: px2rem(18);
    color: #fff;
    font-size: px2rem(26);
    padding: 0 px2rem(20);
    box-sizing: border-box;
    margin-top: px2rem(20);
    font-weight: bold;
    box-shadow: 0 0 px2rem(20) rgba($color: #000000, $alpha: 0.2);
    margin-bottom: px2rem(36);
}
// 列表

.set_meal_list .setMeal_title {
    height: px2rem(78);
    line-height: px2rem(78);
    border-bottom: 1px solid #dfe0e7;
    font-size: px2rem(30);
    color: #333;
    font-weight: bold;
    margin-bottom: px2rem(30);
}
.set_meal_list .setMeal_contet {
    margin-bottom: px2rem(50);
}
.setMeal_contet_top {
    display: flex;
    justify-content: space-between;
    margin-bottom: px2rem(25);
}
.setMeal_contet_top h5 {
    font-size: px2rem(26);
    color: #333;
}
.setMeal_contet_top h5 span {
    display: inline-block;
    width: px2rem(10);
    height: px2rem(10);
    background-color: #bbf51b;
    vertical-align: top;
    margin-top: px2rem(8);
    margin-right: px2rem(16);
}
.setMeal_contet_top p {
    font-size: px2rem(26);
    color: #f07541;
}
.setMeal_contet_bottom {
    font-size: px2rem(22);
    color: #999999;
    display: flex;
    justify-content: space-between;
    margin-top: px2rem(16);
    padding-left: px2rem(25);
    box-sizing: border-box;
}
// 底部
.explain {
    width: 100%;
    border-radius: px2rem(18);
    background-color: #ffffe5;
    padding: px2rem(28);
    box-sizing: border-box;
    margin-bottom: px2rem(20);
}
.explain_title {
    font-weight: bold;
    margin-bottom: px2rem(15);
    font-size: px2rem(26);
    color: #336289;
}
.explain p {
    font-size: px2rem(22);
    color: #333;
    line-height: px2rem(44);
}
</style>